<td-address-page scope="activity" #page *transloco="let t">
    <h1 my-title>{{ t('events-list.title-my') }}</h1>
    <span other-subtitle>{{ t('events-list.title-owned-by') }}</span>

    <td-event-table *ngIf="page.validAddress" [address]="page.address"></td-event-table>
</td-address-page>
